/* eslint-disable react/no-unescaped-entities */
import { useState } from 'react';
import {
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from '@/components/ui/accordion';

type AccordionLearnMoreProps = {
  openWhatIsAldebaran?: boolean;
  openWhyPrepareConsultation?: boolean;
};

type OpenItem = 'what' | 'why' | 'legal' | null;

export const AccordionLearnMore = ({
  openWhatIsAldebaran = false,
  openWhyPrepareConsultation = false,
}: AccordionLearnMoreProps) => {
  const defaultOpen: OpenItem = openWhatIsAldebaran
    ? 'what'
    : openWhyPrepareConsultation
    ? 'why'
    : null;

  const [openItem, setOpenItem] = useState<OpenItem>(defaultOpen);

  const toggle = (item: OpenItem) => (isOpen: boolean) => {
    setOpenItem(isOpen ? item : null);
  };

  return (
    <div className="rounded-2xl">
      <AccordionItem open={openItem === 'what'} onOpenChange={toggle('what')}>
        <AccordionTrigger className="py-3 font-medium text-base">
          C'est quoi Aldebaran ?
        </AccordionTrigger>
        <AccordionContent className="pb-5 pt-0 font-light leading-tight">
          Aldebaran est un assistant médical intelligent créé par des médecins
          pour améliorer la qualité du suivi et de prise en charge des patients.
        </AccordionContent>
      </AccordionItem>

      <AccordionItem open={openItem === 'why'} onOpenChange={toggle('why')}>
        <AccordionTrigger className="py-3 font-medium  text-base">
          Pourquoi faire ?
        </AccordionTrigger>
        <AccordionContent className="pb-5 pt-0 font-light">
          Ce service aide votre médecin à libérer du temps pour une prise en
          charge optimale, tout en facilitant l'échange et en vous aidant à ne
          rien oublier.
        </AccordionContent>
      </AccordionItem>

      <AccordionItem open={openItem === 'legal'} onOpenChange={toggle('legal')}>
        <AccordionTrigger className="py-3 font-medium leading-tight text-base">
          Mentions légales
        </AccordionTrigger>
        <AccordionContent className="pb-5 pt-0 font-light">
          Ce questionnaire est facultatif. Le médecin prendra connaissance de
          vos réponses au moment de la consultation, mais il est possible que le
          médecin ne consulte pas vos réponses avant la consultation. Le médecin
          décidera, selon son jugement professionnel, quels sujets évoqués dans
          ce questionnaire pourront être traités lors de cette consultation.
          Aldebaran n'est pas un service d'urgence. En cas d'urgence médicale,
          veuillez composer le 15. Pour en savoir plus, consultez nos{' '}
          <a
            href="https://aldebaran.care/legal/cgu-patient/"
            className="underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Conditions Générales d'Utilisation
          </a>{' '}
          et notre{' '}
          <a
            href="https://aldebaran.care/legal/politique-protection-donnees"
            className="underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Politique de Protection des Données
          </a>
          .
        </AccordionContent>
      </AccordionItem>
    </div>
  );
};
